import { Navigate } from "react-router";

import { useAppSelector } from "@/stores/hooks";

// The root route on this host. Staff land in the admin console, not on the
// customer homepage, so the two surfaces are distinguishable on arrival.
//
// An unauthenticated arrival starts the sign-in flow rather than showing a
// button: `autoStart` is the intent flag LoginPage already honours. Only THIS
// route sets it — `/login` reached any other way stays passive, which is what
// stops a tab from racing a logout that is still in flight.
export function AdminEntry() {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const restoring = useAppSelector((state) => state.auth.restoring);
  const role = useAppSelector((state) => state.auth.user?.role);

  // The boot refresh has to resolve first: the access token is in memory, so a
  // fresh tab legitimately looks signed out for one round trip.
  if (restoring) return null;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ autoStart: true }} />;
  }
  // Tasks is gated on canManageUsers, so only that role starts there.
  if (role?.canManageUsers === true) return <Navigate to="/admin/tasks" replace />;
  // The console itself needs one of the two admin permissions. Sales and
  // engineering hold neither, so /admin would refuse them; their reason for
  // being on this host is choosing a customer.
  if (role?.canManageMasterData === true) return <Navigate to="/admin" replace />;
  if (role?.canWorkForOthers === true) return <Navigate to="/work-for" replace />;
  return <Navigate to="/admin" replace />;
}
